export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20composition%20of%20fashion%20and%20lifestyle%20elements%20floating%20in%20organized%20chaos%2C%20warm%20terracotta%20and%20soft%20sage%20green%20gradient%20background%2C%20delicate%20product%20silhouettes%20of%20shoes%20bags%20and%20accessories%20arranged%20in%20spreadsheet-like%20grid%20pattern%2C%20soft%20ethereal%20lighting%2C%20contemporary%20editorial%20design%20aesthetic%2C%20sophisticated%20warm%20neutral%20tones%20with%20coral%20accents%2C%20creative%20visual%20merchandising%20concept&width=1600&height=900&seq=hero-main-bg-v2&orientation=landscape"
          alt="OOPBuy Spreadsheet product comparison guide background"
          className="w-full h-full object-cover object-center"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/35"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold font-heading text-white leading-tight max-w-4xl">
          OOPBuy Spreadsheet
          <br />
          <span className="text-accent-300">Guide &amp; Product Lists</span>
        </h1>
        <p className="mt-5 md:mt-6 text-base md:text-lg text-white/80 max-w-2xl leading-relaxed">
          Your ultimate product comparison hub for smarter sourcing decisions. Compare thousands of products across categories using curated spreadsheet buying guides.
        </p>
        <a
          href="https://kaspreadsheet.com/"
          target="_blank"
          rel="noopener nofollow"
          className="mt-8 inline-flex items-center gap-2 px-8 py-3.5 bg-white/15 backdrop-blur-sm text-white rounded-full text-base font-semibold hover:bg-white/25 transition-all cursor-pointer whitespace-nowrap"
        >
          Buy It Now
          <i className="ri-arrow-right-line"></i>
        </a>
      </div>
    </section>
  );
}